/* This example requires Tailwind CSS v2.0+ */
import React from "react";
import {
  GlobeAltIcon,
  LightningBoltIcon,
  MailIcon,
  UsersIcon,
} from "@heroicons/react/outline";
import Digital from "../../images/digital-money.svg"
import Canada from "../../images/canada.svg"
import One from "../../images/one.svg"
const features = [
  {
    name: "100% Canadian",
    description:
      "We are proudly Canadian. All of our operations are completed in Canada by Certus employees, ensuring security and privacy.",
    icon: Canada,
  },
  {
    name: "Fully Digital",
    description:
      "Certus’ digital infrastructure allows us to serve clients across the country from a remote location. This guarantees business owners have access to their dedicated representative as well as their company’s data anytime, anywhere.",
    icon: Digital,
  },
  {
    name: "Real-time Processing",
    description:
      "Our operations are in constant motion, meaning your data is processed in real time, always ensuring an up to date view of your books.",
    icon: LightningBoltIcon,
  },
  {
    name: "1 On 1 Service",
    description:
      "By assigning you a dedicated account representative, hiring Certus is like hiring a CFO.",
    icon: One,
  },
];



export default function Example() {
  return (
   <div className="bg-gray-50 overflow-hidden">
    <div className="relative  py-8 sm:py-10 lg:py-10">
        <svg
          className="absolute top-0 left-full transform -translate-x-1/2 -translate-y-3/4 lg:left-auto  lg:translate-x-1/3 lg:translate-y-1/4"
          width={404}
          height={784}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="8b1b5f72-e944-4457-af67-0c6d15a99f38"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
            </pattern>
          </defs>
          <rect width={404} height={784} fill="url(#8b1b5f72-e944-4457-af67-0c6d15a99f38)" />
        </svg>

        <div className="relative lg:grid lg:grid-cols-2 lg:gap-x-1 justify-right">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl text-center pb-8">
              Our Features
            </h2>
          <div className="mt-1 relative lg:right-32">
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-2 lg:grid-cols-2">
            {features.map((feature) => (
              <div key={feature.name} className="pt-6">
                <div className="flow-root bg-gray-50 rounded-lg px-6 sm:pb-8">
                  <div className="-mt-6">
                    <div textAlign="center"  >
                      <span className=" flex items-center justify-center p-3 bg-secondary rounded-md shadow-lg text-center mr-10 " style={{maxWidth: "80px", justifyItems:"center", marginLeft: "auto" , marginRight: "auto"}}>
                        <feature.icon className="h-8 w-8 text-white" aria-hidden="true"  />
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight text-center">{feature.name}</h3>
                    <p className="mt-5 text-base text-gray-500 lg:text-center" >
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        </div>
    </div>
    </div>
  )
}

